import { trackEvent } from '../../lib/analytics';

export const FETCH_CURRENT_CAMPAIGN_BEGIN   = 'FETCH_CURRENT_CAMPAIGN_BEGIN';
export const FETCH_CURRENT_CAMPAIGN_SUCCESS = 'FETCH_CURRENT_CAMPAIGN_SUCCESS';
export const FETCH_CURRENT_CAMPAIGN_FAILURE = 'FETCH_CURRENT_CAMPAIGN_FAILURE';
export const SET_CAMPAIGN_ID = 'SET_CAMPAIGN_ID';
export const SET_TOOLBAR_VISIBILITY = 'SET_TOOLBAR_VISIBILITY';
export const SET_DISPLAYED_INFLUENCER = 'SET_DISPLAYED_INFLUENCER';
export const DISPLAY_INFLUENCER_FAILURE = 'DISPLAY_INFLUENCER_FAILURE';
export const SET_CURRENT_TOOLBAR_KEY = 'SET_CURRENT_TOOLBAR_KEY';
export const SET_DISPLAYED_SOCIAL_PROFILE = 'SET_DISPLAYED_SOCIAL_PROFILE';
export const DISPLAY_SOCIAL_PROFILE_FAILURE = 'DISPLAY_SOCIAL_PROFILE_FAILURE';

export const fetchCurrentCampaignBegin = (opts) => ({
  type: FETCH_CURRENT_CAMPAIGN_BEGIN,
  opts
});

export const fetchCurrentCampaignSuccess = (campaign, opts) => ({
  type: FETCH_CURRENT_CAMPAIGN_SUCCESS,
  payload: campaign,
  opts
});

export const fetchCurrentCampaignFailure = error => ({
  type: FETCH_CURRENT_CAMPAIGN_FAILURE,
  payload: { error }
});

export const displayInfluencerSuccess = (data, displayedInfluencerTab) => ({
  type: SET_DISPLAYED_INFLUENCER,
  displayedInfluencer: data,
  displayedInfluencerTab
});

export const displaySocialProfileSuccess = (data, displayedProfileTab) => ({
  type: SET_DISPLAYED_SOCIAL_PROFILE,
  displayedSocialProfile: data,
  displayedProfileTab
});

export const displayInfluencerFailure = error => ({
  type: DISPLAY_INFLUENCER_FAILURE,
  payload: { error }
});
export const displaySocialProfileFailure = error => ({
  type: DISPLAY_SOCIAL_PROFILE_FAILURE,
  payload: { error }
});


export function setCampaignId(campaignId) {
  return {
    type: SET_CAMPAIGN_ID,
    campaignId
  };
}
export function setToolbarVisibility(toolbarVisibility) {
  return {
    type: SET_TOOLBAR_VISIBILITY,
    toolbarVisibility
  };
}

export function setDisplayedInfluencer(id, displayedInfluencerTab, offerId, audienceId) {
  return (dispatch, getState) => {
    let url = `/manager/users/${id}/user_details?`;
    let currentTool;
    if (offerId) {
      url += `offer_id=${offerId}&email_body=text_only`;
      currentTool = 'Campaign';
    }
    if (audienceId) {
      url += `audience_id=${audienceId}`;
      currentTool = 'Audience';
    }
    trackEvent('Display Toolbar', `${currentTool} Management`, { toolBarVisible: 'user' });
    fetch(url)
      .then((response) => response.json())
      .then((data) => { dispatch(displayInfluencerSuccess(data, displayedInfluencerTab)); })
      .catch(error => { dispatch(displayInfluencerFailure(error)); });
  };
}

export function setDisplayedSocialProfile(socialProfile, displayedProfileTab) {
  return (dispatch, getState) => {
    let currentTool;
    trackEvent('Display Toolbar', `${currentTool} Management`, { toolBarVisible: 'social_profile' });
    dispatch(displaySocialProfileSuccess(socialProfile, displayedProfileTab));
    /*
        let url = `/manager/social_profiles/${platform}/${extId}/details`;
    fetch(url)
      .then((response) => response.json())
      .then((data) => { dispatch(displaySocialProfileSuccess(data, displayedProfileTab)); })
      .catch(error => { dispatch(displaySocialProfileFailure(error)); });*/
  };
}

export function setCurrentToolbarKey(key) {
  trackEvent(`Display ${key} Toolbar`, 'Campaign Management', { actionType: 'Display Toolbar' });

  return {
    type: SET_CURRENT_TOOLBAR_KEY,
    key
  };
}

export function fetchCurrentCampaign(opts = {}) {
  return (dispatch, getState) => {
    dispatch(fetchCurrentCampaignBegin(opts));
    let currentCampaignId = opts.id || getState().currentCampaign.campaign.id;
    let params = opts;
    delete params['id'];
    let url = `/manager/campaigns/${currentCampaignId}/dashboard/current_campaign.json?${Object.keys(params).map(key => `&${key}=${params[key]}`).join('')}`;
    fetch(url)
      .then((response) => response.json())
      .then((data) => { dispatch(fetchCurrentCampaignSuccess(data, opts)); })
      .then(() => {
        if (opts.callback) {
          opts.callback();
        }
        return true;
      })
      .catch(error => dispatch(fetchCurrentCampaignFailure(error)));
  };
}
